import { AmlUI } from '@arionbanki/aml-ui';
import { Button, Typography } from '@arionbanki/arionui';
import { useAml } from './useAml';

export function Aml() {
	const { config, data, isLoading, state, t, ...props } = useAml();
	const key = Math.random(); // NOSONAR

	if (isLoading || !data) return null;

	return (
		<>
			<Typography className="mb-5" TagName="h3">
				{t('aml_title')}
			</Typography>
			<AmlUI
				getCustomer={`${config.API.customer}/`}
				getQuestionnaireUrl={props.getQuestionnaireUrl}
				isInternalWeb={config.IS_EMPLOYEE_WEB}
				key={key}
				onError={console.error}
				onFinish={props.onFinish}
				questionnaire={data}
				requestConfig={props.requestConfig}
				setQuestionnaireUrl={config.API.setAMLQuestions}
			/>
			{props.showBTN && (
				<Button className="my-5" mode="error" onClick={props.skip}>
					{t('skip_aml_button')}
				</Button>
			)}
		</>
	);
}
